import web_managerSupplier_details from '@/lib/data-service/default/web_managerSupplier_details'
import PreviewImage from '@/page/admin/supplier-management/component/previewImage/index.vue'
import FullImage from '@/page/admin/supplier-management/component/fullImage/index.vue'
import addImgSuffix from '@/lib/common-service/add_img_suffix'
export default {
  data () {
    return {
      loading: false,
      id: '',
      supplier: {},
      srcList: [],
      dialogFullPicVisible: false,
      fullPicSrc: ''
    }
  },
  components: {
    FullImage,
    PreviewImage
  },
  created () {
  },
  mounted () {

  },
  activated () {
    this.id = this.$route.query.id
    this.getSupplierDetail(this.id)
  },
  deactivated() {},
  destroyed () {
  },
  watch: {},
  computed: {},
  filters: {
    filterSupplierStatus(val) {
      if (val === 0) {
        return '待审核'
      } else if (val === 1) {
        return '审核失败'
      } else if (val === 2) {
        return '部分启用'
      } else if (val === 3) {
        return '启用'
      } else if (val === 4) {
        return '平台禁用'
      } else if (val === 5) {
        return '已删除'
      } else if (val === 6) {
        return '未签约'
      } else if (val === 7) {
        return '签约失败'
      } else if (val === 8) {
        return '待设置合同文件'
      } else {
        return ''
      }
    },
    filterAppType(val) {
      if (val === '1') {
        return '机票'
      } else if (val === '2') {
        return '旅游'
      } else {
        return '机票+旅游'
      }
    },
    filterImg(val) {
      let result = addImgSuffix(val)
      return result
    }
  },
  methods: {
    picLoading() {
      let _this = this
      let picSetTimeOut = ''
      picSetTimeOut = setTimeout(() => {
        let formPicArr = document.getElementsByClassName('form-pic')
        let formPicStatus = []
        for (let i in formPicArr.length) {
          formPicStatus.push(-1)
        }
        formPicArr.forEach((value, index) => {
          let complete = value.complete
          formPicStatus[index] = complete ? 1 : -1
        })
        if (formPicStatus.indexOf(-1) >= 0) {
          this.picLoading()
        } else {
          _this.loading = false
        }
      }, 500)
    },
    getSupplierDetail(supplierId) {
      this.loading = true
      web_managerSupplier_details({supplierId}).then(res => {
        this.supplier = res.result
        this.businessLicensePic = this.supplier.businessLicensePic
        this.$nextTick(() => {
          this.picLoading()
        })
      }).catch(() => {
        this.loading = false
      })
    },
    showFullPic(val) {
      this.dialogFullPicVisible = true
      this.fullPicSrc = addImgSuffix(val)
    },
    back() {
      this.$router.go(-1)
    },
    downloadPDF() {
      let url = this.supplier.agreementFile
      window.open(url)
    },
  }
}
